import React, { useCallback } from 'react';

import { ConstructionType } from '../../../Enum/Filters/ConstructionType';
import { Filter } from '../../../Enum/Filters';
import { filterChanged } from '../../../Store/Filter/action';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';

import { useDispatch } from 'react-redux';
import useGetFilterValue from '../../../Hook/Interest/UseGetFilterValue';

const ConstructionTypeFilter: React.FC = () => {
    const dispatch = useDispatch();
    const value = useGetFilterValue(Filter.ConstructionType);

    const selectConstructionType = useCallback(
        (constructionType: ConstructionType): void => {
            dispatch(filterChanged(Filter.ConstructionType, constructionType));
        },
        [dispatch],
    );

    return (
        <>
            <Form className="construction-type-filter" autoComplete="off">
                <Form.Group controlId="construction_type">
                    <Form.Label>Soort woning</Form.Label>
                    <InputGroup>
                        <Form.Check
                            custom
                            checked={value === ConstructionType.Existing}
                            onChange={() => selectConstructionType(ConstructionType.Existing)}
                            type="radio"
                            label="Bestaande bouw"
                            id="constructionTypeFilter1"
                        />
                        <Form.Check
                            custom
                            checked={value === ConstructionType.New}
                            onChange={() => selectConstructionType(ConstructionType.New)}
                            type="radio"
                            label="Nieuwbouw"
                            id="constructionTypeFilter2"
                        />
                    </InputGroup>
                </Form.Group>
            </Form>
        </>
    );
};

export default ConstructionTypeFilter;
